import script from "./DonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DonutChart.vue?vue&type=script&setup=true&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=9bf28102&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf28102"]])

export default __exports__